import { tuple } from 'annotation-tools/utils';
import { BehaviorSubject } from 'rxjs';
import tus from 'tus-js-client';
import { uri } from '../../api-endpoint';

export type StreamValueType =
  | { type: 'progress'; value: [number, number] }
  | { type: 'completed'; url: string | undefined }
  | { type: 'error'; value: Error };

export const uploadFileByTus = <T extends File>(token: string, file: T) => {
  const source$ = new BehaviorSubject<StreamValueType>({
    type: 'progress',
    value: [0, 100]
  });

  const uploader = new tus.Upload(file, {
    endpoint: uri.files,
    chunkSize: 1024 * 1024 * 3,
    metadata: { filename: file.name, filetype: file.type },
    headers: { Authorization: `Bearer ${token}` },
    onError: error => {
      console.error(
        `Failed because: ${error.name}, ${error.message}, ${error.stack}`
      );
      source$.next({ type: 'error', value: error });
    },
    onProgress: (bytesSent: number, bytesTotal: number) => {
      source$.next({ type: 'progress', value: [bytesSent, bytesTotal] });
    },
    onSuccess: () => {
      source$.next({
        type: 'completed',
        url: uploader.url === null ? undefined : uploader.url
      });
      source$.complete();
    }
  });

  uploader.start();

  return tuple(source$.asObservable(), uploader);
};
